/**
 * Shorthands resource - /api/shorthands endpoints
 */
import { getLogger } from '@qwickapps/logging';
const log = getLogger('QwickForge.MiddlewareClient.ShorthandsResource');
export class ShorthandsResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /**
     * List all shorthands for current user
     */
    async list(scope) {
        log.debug('Listing shorthands', { scope });
        const query = scope ? `?scope=${scope}` : '';
        const shorthands = await this.http.get(`/api/shorthands${query}`);
        log.debug('Shorthands listed', { count: shorthands.length });
        return shorthands;
    }
    /**
     * Create a new shorthand
     */
    async create(data) {
        log.debug('Creating shorthand', { trigger: data.trigger });
        const shorthand = await this.http.post('/api/shorthands', data);
        log.debug('Shorthand created', { id: shorthand.id });
        return shorthand;
    }
    /**
     * Update a shorthand
     */
    async update(id, data) {
        log.debug('Updating shorthand', { id });
        const shorthand = await this.http.patch(`/api/shorthands/${id}`, data);
        log.debug('Shorthand updated', { id });
        return shorthand;
    }
    /**
     * Delete a shorthand
     */
    async delete(id) {
        log.debug('Deleting shorthand', { id });
        await this.http.delete(`/api/shorthands/${id}`);
        log.debug('Shorthand deleted', { id });
    }
}
//# sourceMappingURL=ShorthandsResource.js.map